import React from "react";
import { styled } from "@mui/material/styles";
import { Button } from "react-bootstrap";

function SecondaryButton() {
  const SecondaryButton = styled(Button)(({ theme }) => ({
    backgroundColor: `${theme.palette.button.secondary.background} !important`,
    color: `${theme.palette.button.secondary.color} !important`,
    fontWeight: "400",
    border: "none",
    boxShadow: "2px 2px 4px 1px #ccc !important",
    "&:hover": {
      backgroundColor: `${theme.palette.button.secondary.hoverbackground} !important`,
      color: `${theme.palette.button.secondary.hovercolor} !important`,
    },
  }));
  return (
    <div className="secondery-button-size" >
      <SecondaryButton type="submit" className="btn-font">
        EXIT
      </SecondaryButton>
    </div>
  );
}

export default SecondaryButton;
